import { IResultStamp } from "@/api/AppApi/common-interfaces/IResultStamp";
import { IAddress } from "../../address/interfaces/IAddress";
import { IBranch } from "../../company/interfaces/ICompany";
export interface IRegisterParams {
  name: string;
  email?: string;
  mobile?: string;
  password: string;
  password_confirmation: string;
  other_inputs?: any;
}
export interface ISignInParams {
  username: string;
  password: string;
}
export interface IPostRegister extends IResultStamp {
  result?: {
    user: {
      id: number;
      name: string;
      avatar: string;
      email: string;
      mobile: string;
      mobile_fields: {
        number: string;
        country: string;
        code: string;
      };
      registered_at: string;
      is_email_verified: boolean;
      is_mobile_verified: boolean;
    };
    access_token: string;
    refresh_token: string;
  };
}
export interface IUserProfile {
  avatar: string;
  email: string;
  id: number;
  is_email_verified: boolean;
  is_mobile_verified: boolean;
  name: string;
  mobile: string;
  mobile_fields: {
    number: string;
    dial_code_country: {
      selected: boolean;
      iso2: string;
      dial_code: string;
      icon: string;
      name: string;
    };
  };
  other_inputs: any;
  registered_at: string;
  settings: IUpdateSettings;
  address: IAddress;
}
export interface IGetUserProfile extends IResultStamp {
  result?: IUserProfile;
}
export interface IUpdateProfile {
  name: string;
  image?: string;
  email: string;
  mobile: string;
}
export interface IUpdateSettings {
  has_receiving_type: boolean;
  receiving_type: "delivery" | "pickup";
  delivery_address_type: "address" | "current";
  delivery_address_obj: IAddress;
  delivery_time_type: "custom" | "now";
  delivery_time: string | null;
  pickup_branch_obj: IBranch; //
  delivery_address: number;
  pickup_branch: number; //
  pickup_time_type: "custom" | "now";
  pickup_time: string | null;
  delivery_branch_obj: IBranch;
}
export interface IVerifyParams {
  token: string;
}
export interface IPostVerify extends IResultStamp {
  result: {
    id: number;
    name: string;
    avatar: string;
    email: string | null;
    mobile: string | null;
    registered_at: string;
    is_verified: boolean;
  };
}
export interface ISendVerificationCodeParams {
  username:
    | string
    | {
        number: string;
        country: string;
      }; //mobile or email
}
export interface IChangePasswordParams {
  password: string;
  new_password: string;
  new_password_confirmation: string;
}
export interface IPostChangePassword extends IResultStamp {
  result: any;
}

export interface ISendVerifyForgetPasswordParams {
  username: string; //mobile or email
  token: string; //5 chars
}
export interface IPostResetPasswordParams {
  token: string;
  username: string;
  password: string;
  password_confirmation: string;
}
export interface IOtpSignInParams {
  username: string; //mobile or email
  token: string; //5 chars
}
export enum SocialDriverTypes {
  google = "google",
  facebook = "facebook",
  apple = "apple",
}
export interface ISocialLoginParams {
  driver: SocialDriverTypes;
  uid: string;
}
export enum CustomFieldsTypes {
  text = "text",
  textarea = "textarea",
  date = "date",
  time = "time",
  date_time = "date_time",
  options = "options",
  dropdown = "dropdown",
  file = "file",
}
export interface ICustomField {
  id: number;
  input_name: string;
  type: CustomFieldsTypes;
  label: string;
  is_required: boolean;
  is_extra: boolean;
}
